<!--
  Default Layout

  @since 2017-11-06
  @author kdydesign.kim
-->

<template>
  <div
    :class="['page-content-white page-header-fixed page-footer-fixed', {'page-new-window page-toolbar-default': !isNavChecked && !isInstallPage}]">
    <div class="page-container">
      <!--<Top/>-->
      <!--Navigation-->
      <Navigation v-if="isNavChecked"/>

      <!--Page Contents-->
      <div class="page-content-wrapper">

        <div :class="getPageContentClass">
          <!--Global Compoent Template-->
          <loading-dialog ref="globalLoadingDialog" global />
          <alert-dialog ref="globalAlertDialog"/>
          <duplicate-confirm-dialog ref="globalDuplicateConfirmDialog"/>
          <!-- TAMS -->
          <otp-popup ref="otpPopup"/>

          <!-- TAMS, uiData -> current-time 최초 로딩 이후 agentTime 세팅 전 화면 랜더링 대기 -->
          <nuxt v-if="agentTime"/>

          <template v-else>
            <div>
              <fake-top/>
              <fake-footer/>
            </div>
          </template>

        </div>

<!--        <div :class="pageContentClassName">-->
<!--          &lt;!&ndash;Global Compoent Template&ndash;&gt;-->
<!--          <loading-dialog ref="globalLoadingDialog" global />-->
<!--          <alert-dialog ref="globalAlertDialog"/>-->
<!--          <duplicate-confirm-dialog ref="globalDuplicateConfirmDialog"/>-->

<!--          &lt;!&ndash; TAMS, uiData -> current-time 최초 로딩 이후 agentTime 세팅 전 화면 랜더링 대기 &ndash;&gt;-->
<!--          <nuxt v-if="agentTime"/>-->
<!--        </div>-->

      </div>
    </div>
    <!-- 서버연결 끊김 발생 시 재로그인 진행 알림 팝업 -->
    <process-dialog ref="reconnDialog"
                    :top-msg="$t('cmn.alert_reconnectDevice')"
                    :btn-text="$t('cmn.btn_disconnect')"
                    :bottom-msg="$t('cmn.title_reconnectCount')"
                    :total-process="3"
                    :current-process="errorCnt"
                    @cancel="disconnectServer"
    />

    <!-- 로그인 / 세션 / 서버연결 끊김 발생 시 강제 로그아웃 팝업 -->
    <confirm-dialog ref="reloginDialog"
                    :prevent-close="true"
                    :footer-btn-list="reloginBtnList"
                    @onApply="onClickRedirectLogin"
    />

    <!-- 유휴시간 초과 시 잠금화면 -->
    <lock-screen-popup ref="lockScreenRef"
                       @releaseLockMode="releaseLockMode"
    />

    <!--객체 중복 처리 팝업-->
    <confirm-dialog ref="objectDuplicateDialog"
                    :prevent-close="true"
    />

    <!--라이선스 만료 팝업-->
    <license-expired-popup ref="licenseExpiredRef"
    />

    <!-- Multi R/W 시 페이지 이동 컨펌 다이얼로그 -->
    <guard-confirm-dialog ref="guardConfirmDialog" />

  </div>
</template>

<script>
  // component
  import Navigation from '~/components/layout/navigation/Navigation'
  import ProcessDialog from '~/components/dialog/ProcessDialog'
  import LockScreenPopup from '~/components/popUp/LockScreenPopup'
  import LicenseExpiredPopup from '~/components/popUp/LicenseExpiredPopUp'

  // TAMS
  import LoadingDialog from '~/components/dialog/LoadingDialog'
  import MultiRWGuardConfirmDialog from '~/components/dialog/MultiRWGuardConfirmDialog'
  import SecuiOtpPopup from '~/components/pageComponents/common/SecuiOtpPopup'
  import FakeTop from '~//components/layout/FakeTop'
  import FakeFooter from '~//components/layout/FakeFooter'

  import { menuCodeToPath } from '~/utils/multirw'

  // Fail-over
  import { connectBackupDevice, checkBackupDeviceMaster, connectBackupDeviceSocket } from '~/utils/failover.js'

  // 스토어 헬퍼
  import { createNamespacedHelpers } from 'vuex'

  // 스토어 헬퍼 메서드
  const { mapActions: authMapAction, mapState: authToken } = createNamespacedHelpers('common/authenticate/')
  const { mapGetters: langMapGetters } = createNamespacedHelpers('common/locale/')
  const { mapState: commonMapState, mapMutations: commonMapMutations, mapActions: commonMapActions } = createNamespacedHelpers('common/common/')
  const { mapState: lockModeMapState, mapMutations: lockModeMapMutations } = createNamespacedHelpers('common/lockmode/')

  const {mapState: navigationMapState, mapMutations: navigationMapMutations} = createNamespacedHelpers('common/navigation')
  const { mapMutations: objectCommonMapMutations } = createNamespacedHelpers('cm/objectSecProfile/object/objectSettings/common')
  const { mapMutations: ipsObjectCommonMapMutations } = createNamespacedHelpers('cm/objectSecProfile/object/ipsObjectSettings/common')

  export default {
    name: 'Default',
    middleware: ['authenticated', 'multirw'],
    components: {
      Navigation,
      ProcessDialog,
      LockScreenPopup,
      LicenseExpiredPopup,
      // TAMS
      LoadingDialog,
      'guard-confirm-dialog': MultiRWGuardConfirmDialog,
      'otp-popup': SecuiOtpPopup,
      FakeTop,
      FakeFooter
    },
    head () {
      // // 호스트를 통해 VS 새창을 띄울 경우 VS 이름으로 브라우저 타이틀 변경
      // if (this.vsName) {
      //   return {
      //     titleTemplate: `${this.vsName} | %s`
      //   }
      // } else {
      //   return {}
      // }
      return {}
    },
    /*
      내부 모델 설명

      errorCnt: 재접속 카운트.
      idleTime: 유휴시간 카운트. (유휴시간이 길어지면 카운트가 증가하고, 사용자가 작업하거나 Lock 스크린을 풀면 0으로 초기화)
      alertList: 장비의 경고 알람 리스트.
      isHaLogout: HA 전환 시 브라우저의 unload에서 로그아웃을 막기위한 Flag로 사용.
      isHaReconn: 장비가 HA 모드인 경우에 true로 설정됨. HA Master에서 재접속 카운트 Flag로 사용.
      isHaBackup: 현재 장비가 Backup Master일 경우 true 설정. 재접속 카운트 및 Backup master 알림 팝업 출력 시 사용.
      healthCheckOpts: 장비 상태체크에 사용하는 객체 모델.
      isFinFailOver: HA 상태에서 Backup 장비의 state가 Master로 변경된 경우 설정되는 Flag. 평상시에는 null로 설정되어 Fail-over 시 마스터로 전환되는 기능을 차단한다.
      checkOverIdleTimer: 유휴시간 체크 타이머 객체.
      licenseExpiredDay: 로그인 시 라이선스 만료여부 확인.
    */
    data () {
      return {
        self: this,
        errorCnt: 0,
        idleTime: 0,
        alertList: [],
        isHaLogout: false,
        isHaReconn: false,
        isHaBackup: false,
        healthCheckOpts: {
          isAlive: true,
          deviceIP: '',
          devicePort: 443,
          healthCheckTimer: null
        },
        isFinFailOver: null,
        checkOverIdleTimer: null,
        licenseExpiredDay: null,
        // TAMS
        isDetectLock: false,
        init: true
      }
    },
    computed: {
      ...authToken([
        'hakey',
        'authToken',
        'authIssueDate',
        'authRefreshToken',
        'encryptionAesKey'
        // TAMS
        // 'isLogout'
      ]),
      ...langMapGetters([
        'getCurrentLocale'
      ]),
      ...commonMapState([
        'uiData',
        'newWindows',
        'preventLock',
        'agentTime',
        'isShowNav',
        'isContentsAreaNoPadding'
      ]),
      ...lockModeMapState([
        'isLock'
      ]),
      ...navigationMapState([
        'menu',
        'homePath'
      ]),
      isNewWindow () {
        return this.$route.query.newWindow
      },
      isGeWindow () {
        try {
          return this.$route.query.geWindow || this.$store.getters['common/authenticate/isExistGeToken']
        } catch (e) {
          return false
        }
      },
      ccFlag () {
        return Number(this.$store.state.common.common.uiData.system.cc_flag) === 1
      },
      isNavChecked () {
        let isNavFlag = this.$route.query.newWindow === void 0
        if (this.$route.path.startsWith('/install') === true) {
          isNavFlag = false
        } else if (this.$route.query.vsType !== void 0) {
          isNavFlag = true
        }
        return isNavFlag
      },
      isInstallPage () {
        if (this.$route.path.startsWith('/install') === true) {
          return true
        }
        return false
      },
      reloginBtnList () {
        return [
          {
            text: this.$t('cmn.ok'),
            color: 'primary',
            type: 'apply'
          }
        ]
      },
      getPageContentClass () {
        try {
          let className = this.isShowNav ? 'page-content' : 'page-content marL0'
          if (this.isContentsAreaNoPadding) {
            className += ' pad0 page-content-no-scrollbar'
          }
          return className
        } catch (e) {
          return 'page-content marL0'
        }
      }
      // pageContentClassName () {
      //   return this.$route.path.indexOf('/dev/test/embed') > -1 ? 'page-content-no-header' : 'page-content'
      // }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
      // TAMS (click 감지 안 됨 현상 존재)
      window.addEventListener('mousedown', this.onClickUpdateIdleTimer)

      // document.onmousedown = this.onClickUpdateIdleTimer

      // TAMS - 마우스/키보드 감지 이벤트
      // window.addEventListener('mousemove', this.onClickUpdateIdleTimer)
      // window.addEventListener('mousedown', this.onClickUpdateIdleTimer)
      // window.addEventListener('keydown', this.onClickUpdateIdleTimer)

      // Prism
      $('body').addClass('page-prism')

      if (this.$route.query.geWindow) {
        if (_.get(this, ['$store', 'state', 'common', 'common', 'apiPrefix', 'length'], 0) === 0) {
          this.$store.commit('common/common/setApiPrefix', `/GE:${this.$route.query.geWindow}/`)
        }
      }

      // 새창이 아닌 경우에만 로그아웃 되도록
      if (this.$route.query.newWindow === void 0) {
        // 브라우저 새로고침, 닫을 시 로그아웃
        window.addEventListener('beforeunload', () => {
          // // TAMS
          // if (!this.isLogout && !_.isUndefined(this.authToken)) {
          //   // 새창 윈도우 모두 종료
          //   this.$store.commit('common/common/initNewWindows')
          //   sessionStorage.setItem('NEED_LOGOUT', this.authToken)
          // } else {
          //   this.unloadLogout()
          // }
          this.unloadLogout()

          // IE에서 페이지를 벗어나시겠습니까? 메세지 제거
          return undefined
        })
      } else {
        this.setShowGnbNav(false)

        // 새창인 경우 브라우저 새로고침 시 창이 닫히도록 (VRI, VWI, 일반 새창)
        window.addEventListener('unload', () => {
          if (window.opener) {
            window.opener.$nuxt.$store.commit(`common/common/delClosedWindows`)
          }
          window.close()
        })
      }
    },
    mounted () {
      // 스토어에 전역 컴포넌트 저장
      this.$store.commit('common/common/setGlobalComponent', {
        alertDialog: this.$refs.globalAlertDialog,
        reloginDialog: this.$refs.reloginDialog,
        loadingDialog: this.$refs.globalLoadingDialog,
        // loadingDialog: this.$loader,
        duplicateConfirmDialog: this.$refs.globalDuplicateConfirmDialog,
        // TAMS
        lockScreenPopup: this.$refs.lockScreenRef,
        otpPopup: this.$refs.otpPopup
      })

      // NGF 객체 목록 초기 설정
      this.setObjectList()
      // IPS 객체 목록 초기 설정
      this.setIpsObjectList()

      // TAMS
      this.$nextTick(() => {
        // ui-data 로드 전 로딩 표시
        this.$loader.show()
      })
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.handleScroll)

      // 소켓 정보
      this.disconnectServer()

      // 타이머가 이미 존재하면 Clear
      this.releaseCheckIdleTimer()

      // Click 전역 이벤트 제거
      // TAMS (click 감지 안 됨 현상 존재)
      window.removeEventListener('mousedown', this.onClickUpdateIdleTimer)
      // TAMS - 마우스/키보드 감지 이벤트
      // window.removeEventListener('mousemove', this.onClickUpdateIdleTimer)
      // window.removeEventListener('mousedown', this.onClickUpdateIdleTimer)
      // window.removeEventListener('keydown', this.onClickUpdateIdleTimer)

      // Prism
      // window.removeEventListener('beforeunload')

      // 셀프 객체 초기화
      this.self = null
    },
    methods: {
      ...authMapAction([
        'logout',
        'unloadLogout'
      ]),
      ...commonMapMutations([
        'setShowGnbNav'
      ]),
      ...commonMapActions([
        'initNewWindows',
        'loadEventCode'
      ]),
      ...lockModeMapMutations([
        'setIsLockMode'
      ]),
      ...navigationMapMutations([
        'setAuthAlarm',
        'setAuthSync',
        'setAuthSyncConfig',
        'setTicketEvent',
        'setHomePath'
      ]),
      ...objectCommonMapMutations([
        'setObjectList'
      ]),
      ...ipsObjectCommonMapMutations({
        setIpsObjectList: 'setObjectList'
      }),
      handleScroll () {
        // TODO: SPA에 맞도록 변경 필요
        $('.page-header, .page-footer-wrapper').css('margin-left', 0 - document.documentElement.scrollLeft)

        // rev.19530 스크롤시 화면위로 그림자 생성
        const jbOffset = $('.page-header-fixed').offset()
        if (document.documentElement.scrollTop > jbOffset.top) {
          $('.page-header').addClass('page-header-shadow')
        } else {
          $('.page-header').removeClass('page-header-shadow')
        }
      },
      /*
        이름: initHealthCheck
        설명: 장비의 헬스체크용 Websocket을 생성한다.
      */
      initHealthCheck (targetIp = '') {
        // 주소창에서 프로토콜 가져오기
        const webSockProtocol = window.location.protocol.match(/https/) ? 'wss' : 'ws'

        // 장비 IP 가져오기
        const devIP = (targetIp === '') ? this.healthCheckOpts.deviceIP : targetIp

        // 웹소켓 주소
        const healthUri = `${webSockProtocol}://${devIP.indexOf(':') > -1 ? `[${devIP}]` : devIP}:${webSockProtocol === 'wss' ? this.healthCheckOpts.devicePort : 80}/ws/connect?token=${this.authToken}`

        // 웹소켓 객체가 있고, 소켓 상태가 연결되어 있음일 경우 리턴
        if (this.healthCheck && this.healthCheck.readyState === 1) {
          return true
        }

        // 웹소켓 생성
        this.healthCheck = new WebSocket(healthUri)

        // 웹소켓이 연결될 경우 이벤트 핸들러
        this.healthCheck.onopen = this.onOpenIsAliveDevice

        // 서버에서 응답할 경우 이벤트 핸들러
        this.healthCheck.onmessage = this.onMessageDeviceStatus

        // 웹소켓이 끊어진 경우 이벤트 핸들러
        this.healthCheck.onclose = this.onCloseIsAliveDevice
      },
      /*
        이름: releaseLockMode
        설명: 비밀번호가 일치하면 Common 스토어의 isLock을 false로 변경하고, 타이머를 재설정한다.
      */
      releaseLockMode () {
        // Lock 모드 해제
        this.setIsLockMode(false)

        // 타이머 재설정
        this.setCheckIdleTimer()
      },
      /*
        이름: disconnectServer
        설명: 장비와의 접속을 종료한다. 파라미터로 다국어 라벨 키 이름을 전달받는다.
      */
      disconnectServer (label = 'healthCheckFailMsg') {
        // 재시도 팝업 숨김
        if (this.$refs.reconnDialog) {
          this.$refs.reconnDialog.hide()
        }

        // 경고 알람 출력
        this.$refs.reloginDialog.show(this.$t(`msg.${label}`))

        // 커넥팅 카운트 초기화
        this.errorCnt = 0

        // 모든 타이머 제거
        clearInterval(this.healthCheckOpts.healthCheckTimer)

        // 웹-소켓 끊기
        this.healthCheckOpts.isAlive = false

        // 소켓 종료
        if (this.healthCheck) {
          this.healthCheck.close()
        }
      },
      /*
        이름: setCheckIdleTimer
        설명: 유휴시간을 측정하는 타이머를 설정한다.
      */
      setCheckIdleTimer () {
        // 유휴시간값 초기화
        this.idleTime = 0

        // 타이머 종료
        this.releaseCheckIdleTimer()

        // 타이머 실행
        this.checkOverIdleTimer = setInterval(this.checkOverIdleTime, 60000)
      },
      /*
        이름: checkOverIdleTime
        설명: 유휴시간을 증가시키고, 유휴시간을 초과하였는지 확인한다.
      */
      checkOverIdleTime () {
        // 유휴시간 증가
        this.idleTime++

        // 유휴시간 초과 확인
        this.checkIdleTimeAction()
      },
      /*
        이름: callReconnService
        설명: 서비스에 끊겼을 경우 재연결을 시도한다. (정확하게는 5초마다 에러 카운트를 증가 시키고, 3이 넘으면 강제 종료한다.)
      */
      callReconnService () {
        const self = this.self

        // 웹소켓이 살아있는 경우 (웹소켓도 끊어지면 웹소켓 쪽에서 재연결을 시도한다.)
        if (self.healthCheckOpts.isAlive) {
          // 재연결 시도 팝업 출력
          if (!self.$refs.reconnDialog.getShowState()) {
            self.$refs.reconnDialog.show()
          }

          // 에러 카운트가 3회를 초과하면 경고 메세지와 함께 로그인 화면으로 돌아간다.
          if (self.errorCnt < 3) {
            // 에러 카운트 + 1
            self.errorCnt++

            // 재연결 시도 - 웹소켓 Ping 호출
            setTimeout(() => {
              self.healthCheck.send('ping')
            }, 5000)
          } else {
            // 에러 카운트가 3회 초과시 서버와의 접속 종료
            self.disconnectServer()
          }
        }
      },
      /*
        이름: onClickRedirectLogin
        설명: 로그인 화면으로 리다이렉트한다.
      */
      onClickRedirectLogin () {
        // 새창일 경우 강제종료
        if (this.$route.query.newWindow) {
          window.close()
        } else {
          window.location.href = '/'
        }
      },
      /*
        이름: setCheckIdleTimer
        설명: 타이머를 초기화하고 타이머 객체를 null로 변경한다.
      */
      releaseCheckIdleTimer () {
        clearInterval(this.checkOverIdleTimer)

        this.checkOverIdleTimer = null
      },
      /*
        이름: checkIdleTimeAction
        설명: 유휴시간 설정에 따른 잠금/로그아웃 동작 실행 (TAMS)
              isUpdate true 시, 유휴시간이 초과되지 않았따면, 타이머 갱신, 재시작
      */
      checkIdleTimeAction (isUpdate = false) {
        const adminGeneral = this.uiData.admin_general

        if (typeof adminGeneral['system.admin.account_idle_lock_t_num'] !== 'undefined' &&
          typeof adminGeneral['system.admin.account_idle_logout_t_num'] !== 'undefined') {
          if (isUpdate) { // 키보드, 마우스 움직임 감지 시 업데이트
            // 타이머 갱신
            this.releaseCheckIdleTimer()

            // 타이머 재시작
            this.setCheckIdleTimer()
          } else {
            const guiIdleLockTime = parseInt(adminGeneral['system.admin.account_idle_lock_t_num']),
              guiIdleLogoutTime = parseInt(adminGeneral['system.admin.account_idle_logout_t_num'])

            if (this.ccFlag) { // CC 인증 모드
              if (guiIdleLogoutTime <= this.idleTime) { // 유휴 로그아웃 시간 초과 시
                this.execIdleLogout()
              }
            } else { // 기본 동작
              // TAMS - #57500 - [TAC-7566 중소기업은행] TAMS GUI 세션 timeout 해제 요청
              let newWindowPreventLock = false
              for (let key in this.newWindows) {
                const popup = this.newWindows[key]
                if (popup && !popup.closed) {
                  const checkPreventLock = _.get(popup, ['$nuxt', '$store', 'state', 'common', 'common', 'preventLock'], false)
                  if (checkPreventLock) {
                    newWindowPreventLock = checkPreventLock
                    break
                  }
                }
              }

              // 모니터링 화면, 특수 동작 화면 (this.preventLock 옵션 사용 시) 구분
              // 팝업창 내 preventLock 화면 여부 체크 (newWindowPreventLock)
              if (!this.preventLock && !newWindowPreventLock && guiIdleLockTime <= this.idleTime) { // 유휴 잠금 시간 초과 시
                if (guiIdleLogoutTime <= this.idleTime) { // 로그아웃 금지 상태가 아니고 유휴 로그아웃 시간 초과 시
                  this.execIdleLogout()
                } else { // 유휴 로그아웃 시간 미만 시
                  this.execIdleLockScreen()
                }
              }
            }
          }
        }
      },

      /*
        이름: execIdleLogout
        설명: 유휴시간 자동 로그아웃 시간이 지났다면, 로그아웃 처리를 한다. (TAMS)
              실제 수행 로직 부분
      */
      execIdleLogout () {
        // 유휴시간 초기화
        this.idleTime = 0

        // 윈도우 객체 종료 / state 초기화
        this.initNewWindows()

        // 타이머 종료
        this.releaseCheckIdleTimer()

        // TAMS
        if (this.isNewWindow) {
          window.close()
        } else {
          // // 강제 로그아웃
          // this.logout()

          // 강제 로그인 페이지 없이 사용자 인지되도록 개선 (서버만 로그아웃 처리)
          this.unloadLogout()

          // 네비게이션 가드 작동
          this.setIsLockMode(true)

          this.$refs.reloginDialog.show(this.$t('msg.reloginDialogMsg'))

          if (this.$loader.isShow) {
            this.$loader.hide()
          }
        }
      },

      /*
        이름: execIdleLockScreen
        설명: 유휴시간 화면 잠금 시간이 지났다면 잠금 화면을 출력한다. (TAMS)
              실제 수행 로직 부분
      */
      execIdleLockScreen () {
        if (!this.$refs.lockScreenRef.isShow) {
          // 잠금화면 출력
          this.$refs.lockScreenRef.show(this.uiData.user.login_id)

          // 네비게이션 가드 작동
          this.setIsLockMode(true)
        }
      },

      /*
        이름: onClickUpdateIdleTimer
        설명: 유휴시간이 지났다면 잠금 화면을 출력하고, 지나지 않았다면 타이머를 재생성한다.
      */
      onClickUpdateIdleTimer () {
        try {
          // TAMS 감지 이벤트 동시 발생으로 인한 동작 최소화
          if (!this.isDetectLock) {
            this.isDetectLock = true // lock
            // 서버 간 유휴상태 사용중으로 변경 (0: 사용중, 1: 유휴상태)
            this.$store.commit('common/common/setIsIdle', 0)

            // GUI 시스템 설정
            if (this.uiData) {
              // 공통 설정, 관련 내용 존재 시
              if (this.uiData.hasOwnProperty('admin_general')) {
                if (!this.isNewWindow || this.ccFlag) {
                  this.checkIdleTimeAction(true)
                }
              }
            }
            this.isDetectLock = false // unlock
          }
        } catch (e) {}
      },
      /*
        이름: onOpenIsAliveDevice
        설명: 장비와 소켓간 연결이 성공하면 호출한다.
      */
      onOpenIsAliveDevice () {
        // 에러 카운트 초기화
        this.errorCnt = 0

        // 재접속 팝업 숨김
        if (this.$refs.reconnDialog) {
          this.$refs.reconnDialog.hide()
        }

        // 소켓 상태가 연결되었을 경우 서버에 Ping 호출
        if (this.healthCheck.readyState === 1) {
          // 최초 Send 호출
          this.healthCheck.send({
            data: 'ping'
          })

          // 타이머 동작 시작 (20초 주기마다 Ping 호출)
          if (this.healthCheckOpts.healthCheckTimer) {
            clearInterval(this.healthCheckOpts.healthCheckTimer)
          }

          // 장비상태 체크 타이머 - Fail-over시에는 타이머를 설치하지 않는다.
          this.healthCheckOpts.healthCheckTimer = setInterval(() => {
            this.healthCheck.send('ping')
          }, 20000)
        }
      },
      /*
        이름: onMessageDeviceStatus
        설명: 서버에서 응답한 내용을 전달받는다.
      */
      onMessageDeviceStatus (receive) {
        try {
          // 웹소켓으로 전달된 데이터를 JSON.parse로 자바스크립트 객체로 변환
          const deviceSocketData = JSON.parse(receive.data)

          // 타입에 따라 동작 정의
          switch (deviceSocketData.type) {
            // 장비 Health check 부분 -> 장비 재접속 출력
            case 'status':
              // HA 구성 시 Master가 변경되면 변경된 Master로 Redirect
              const haInfo = deviceSocketData.ha || null

              // HA 정보가 있고 VS가 아닌경우
              if (haInfo && !this.vsId) {
                try {
                  // 운용 모드가 stand-alone이 아니고, mmbr 멤버가 있는 경우
                  if (haInfo.mode.toLowerCase() !== 'stand-alone' && haInfo.mmbr.length > 0) {
                    // 현재 HA 장비의 UUID 가져오기
                    const hostUuid = this.uiData.system.host_uuid || ''

                    // 현재 장비의 UUID로 장비의 Role 구하기
                    const currentHost = haInfo.mmbr.findIndex((haMember) => haMember.mmbr_uuid === hostUuid)

                    // 현재 장비 HA 데이터 가져오기
                    const currentHostHa = hostUuid && haInfo.mmbr[currentHost]

                    // 현재 장비의 State가 Master이고, Role이 Master가 아닌 경우
                    if (currentHostHa.state === 'master' && currentHostHa.role !== 'master') {
                      this.isFinFailOver = true
                    } else if (currentHostHa.state !== 'master' && currentHostHa.role !== 'master') {
                      // 현재 장비의 State가 Master가 아니고, Role도 Master가 아닌 경우
                      if (this.isFinFailOver !== null) {
                        // Failover 상태가 끝난 경우, Master 접속
                        this.connectMasterDevice(hostUuid, haInfo.mmbr)
                      }
                    }
                  }
                } catch (e) {
                  this.$log('[HA data error] : There is no HA Mode information.')
                }
              }

              // 만약에 장비 서비스 상태가 false 인 경우
              if (!deviceSocketData.data) {
                // 서비스 재연결 함수 호출
                this.callReconnService()
              } else {
                // 서비스가 정상이면 카운트 초기화
                this.errorCnt = 0

                // 재시도 팝업 숨김
                if (this.$refs.reconnDialog) {
                  this.$refs.reconnDialog.hide()
                }
              }
              break
            // Prism 임시 (web socket 경고 부분 해제)
            // // 이벤트 경고알람 등록부분
            // case 'alert':
            //   // 경고 알람이 들어오면, 최신 데이터를 앞 인덱스로 추가. (소켓으로 들어오는 경고 알람이 이미 추가된 알람보다 무조건 최신 로그.)
            //   if (deviceSocketData.data.length > 0) {
            //     this.alertList = [...deviceSocketData.data, ...this.alertList]
            //   }
            //   break
          }
        } catch (e) {
          this.$log('[Websock receive error msg] : ', e)
        }
      },
      /*
        이름: onCloseIsAliveDevice
        설명: 장비의 연결상태가 끊어지면 호출한다. (웹소켓이 끊긴 경우)
      */
      onCloseIsAliveDevice () {
        // HA 정보 저장
        const haInfo = this.uiData.ha || null
        const guiPort = String(_.get(this.uiData, ['system', 'gui_port'], 433))

        // 타이머 객체 소멸
        setInterval(this.healthCheckOpts.healthCheckTimer)

        // HA 정보가 있고 VS가 아니면 다음단계 진행
        if (haInfo && !this.vsId) {
          // ha.mmbr 리스트에서 현재 장비 IP 정보 가져오기
          const currentMmbr = haInfo.mmbr.filter(haMember => haMember.ip === this.healthCheckOpts.deviceIP)

          // HA 모드에서 Stand-alone이 아니고, state가 Master인 경우 HA 모드 재접속 수행
          if (haInfo.mode.toLowerCase() !== 'stand-alone' && currentMmbr[0].state === 'master') {
            // HA 모드 재접속 수행
            this.haReConnection(haInfo.mmbr, guiPort)
          } else {
            // Stand-Alone 이고, state가 Master가 아닌 경우 일반타입의 재접속 수행
            this.standAloneReConnection()
          }
        } else {
          // HA 정보가 없는 경우 일반타입의 재접속 수행
          this.standAloneReConnection()
        }
      },
      /*
        이름: haReConnection
        설명: HA 상태에서 Fail-over 상황이 발생한 경우 재접속 메서드. (웹소켓이 끊긴 경우)
      */
      async haReConnection (haMemberList = [], guiPort) {
        // self에 this 객체 저장
        const self = this.self

        // 재연결 시도 팝업 출력
        if (!self.$refs.reconnDialog.getShowState()) {
          self.$refs.reconnDialog.show()
        }

        // 에러 카운트가 1회를 초과하면 경고 메세지 출력
        if (self.errorCnt < 1) {
          // 에러 카운트 + 1
          self.errorCnt++

          // 재연결 시도 (재연결 시도 팝업 출력)
          setTimeout(self.initHealthCheck, 5000)
        } else {
          // 현재 HA 장비의 UUID 가져오기
          const hostUuid = self.uiData.system.host_uuid || ''

          // 멤버 리스트가 존재하고, UUID가 있으면 다음단계 진행
          if (haMemberList.length > 0 && hostUuid !== '') {
            // 재접속 팝업 종료
            if (this.$refs.reconnDialog) {
              this.$refs.reconnDialog.hide()
            }

            // 로딩 팝업 출력
            this.$loader.show()

            // Master인 장비에 접속
            const succConvertHa = await this.connectHaMemberDevice(hostUuid, haMemberList, guiPort)

            // HA 변환에 실패한 경우 강제 로그아웃
            if (!succConvertHa) {
              // 로딩 팝업 숨김
              this.$loader.hide()

              // 강제 로그아웃
              self.disconnectServer('default_popup_failOver_failConnMaster')
            }
          } else {
            // 없으면 경고 메세지 출력 후 강제 로그아웃
            self.disconnectServer('default_popup_failOver_failConnMaster')
          }
        }
      },
      /*
        이름: connectMasterDevice
        설명: HA 상태에서 Fail-over 시 State가 master인 장비에 접속한다.
      */
      async connectMasterDevice (hostUuid, haMemberList) {
        // HA 연동 성공 Flag
        let masterIp = ''

        // HOST 장비를 제외한 장비 목록 반복 시작
        for (const haMember of haMemberList.filter((haInfo) => haInfo.mmbr_uuid !== hostUuid)) {
          try {
            // HA 장비에서 state가 Master인 장비 찾기
            if (haMember.state === 'master') {
              // Master인 장비에 웹소켓 연결
              await connectBackupDeviceSocket(haMember.ip, this.healthCheckOpts.devicePort, this.authToken)

              // 마스터 장비 체크 대기
              await checkBackupDeviceMaster()

              // 로그아웃 방지
              this.isHaLogout = true

              // Master IP 설정
              masterIp = haMember.ip

              // HTTP 프로토콜 확인
              const protocol = window.location.protocol

              // Redirect 시 hakey 쿼리 스트링으로 전달
              const redirectUri = `${protocol}//${masterIp.indexOf(':') > -1 ? `[${masterIp}]` : masterIp}:${protocol === 'https:' ? this.healthCheckOpts.devicePort : 80}?hakey=${this.hakey}`

              // Master 상태인 Backup 장비로 Redirect
              window.location.href = redirectUri
            }
          } catch (e) {
            return false
          }

          return true
        }
      },
      /*
        이름: connectHaMemberDevice
        설명: HA 멤버 장비 목록에서 Master인 장비를 검색하여 접속한다.
      */
      async connectHaMemberDevice (hostUuid, haMemberList, guiPort) {
        // HA 연동 성공 Flag
        let masterIp = ''
        let succConvertHa = false

        // 로딩 팝업 출력
        this.$loader.show({
          message: this.$t('msg.default_popup_failOver_BackupMaster')
        })

        // HOST ID를 제외한 나머지 멤버로 새창열기
        for (const haMember of haMemberList.filter((haInfo) => haInfo.mmbr_uuid !== hostUuid)) {
          // 창이 닫히면 접속 확인
          try {
            // url
            let url = `https://${haMember.ip}`
            if (guiPort && guiPort !== '443') {
              url += `:${guiPort}`
            }
            url += '/cert-warning'
            // 접속 요청
            await connectBackupDevice(url, '', 'menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=1400px,height=800px')

            // 접속 성공 시 웹소켓 연결
            await connectBackupDeviceSocket(haMember.ip, this.healthCheckOpts.devicePort, this.authToken)

            // 마스터 장비 체크 대기
            const masterUri = await checkBackupDeviceMaster()

            // 마스터 장비 찾기
            for (const mmbr of masterUri.mmbr) {
              // State가 Master인 장비가 있으면 Redirect
              if (mmbr.state === 'master') {
                // HA 전환 성공 Flag 설정
                succConvertHa = true

                // 로그아웃 방지
                this.isHaLogout = true

                // Master IP 설정
                masterIp = mmbr.ip

                // HTTP 프로토콜 확인
                const protocol = window.location.protocol

                // Redirect 시 hakey 쿼리 스트링으로 전달
                const redirectUri = `${protocol}//${masterIp.indexOf(':') > -1 ? `[${masterIp}]` : masterIp}:${protocol === 'https:' ? this.healthCheckOpts.devicePort : 80}?hakey=${this.hakey}`

                // Master 상태인 Backup 장비로 Redirect
                window.location.href = redirectUri
                break
              }
            }
          } catch (e) {
            // 다음 단계 진행
            this.$log(`[Backup equipment connection fail] : ${haMember.ip} Failed to connect the equipment. Connect to the equipment listed below.`)
          }
        }

        // 로딩 팝업 숨김
        this.$loader.hide()

        return succConvertHa
      },
      /*
        이름: standAloneReConnection
        설명: 장비의 동작 상태가 HA가 아닌 경우 또는 MGMT HOST로 접속한 경우 접속이 끊기면 호출하는 일반적인 재접속 메서드.
      */
      standAloneReConnection () {
        // 장비가 살아있는 경우
        if (this.healthCheckOpts.isAlive) {
          // 재연결 시도 팝업 출력
          if (!this.$refs.reconnDialog.getShowState()) {
            this.$refs.reconnDialog.show()
          }

          // 에러 카운트가 3회를 초과하면 경고 메세지와 함께 로그인 화면으로 돌아간다.
          if (this.errorCnt < 3) {
            // 에러 카운트 + 1
            this.errorCnt++

            // 재연결 시도 (재연결 시도 팝업 출력)
            setTimeout(this.initHealthCheck, 5000)
          } else {
            // 에러 카운트가 3회 초과시 서버와의 접속 종료
            this.disconnectServer()
          }
        }
      },
      async initRoute () {
        // TAMS, 로그인 직후 최 초 한번만 실행 됨
        if (this.init) {
          this.init = false
          try {
            const endFirstNodeSearch = (menu, uri = '') => {
              if (menu.length > 0) {
                const firstMenu = menu[0]
                uri += `/${(firstMenu.hasOwnProperty('children')) ? endFirstNodeSearch(firstMenu.children, firstMenu.key) : firstMenu.key}`
              }
              return uri
            }
            await this.setHomePath(endFirstNodeSearch(this.menu))

            // 특정 메뉴 타겟팅된 newWindow, geWindow 가 아닐 경우에만 Home path로 이동
            if (this.$route.path === '/' && !(this.isNewWindow || this.isGeWindow)) {
              this.$router.replace({path: this.homePath})
            }
          } catch (e) {
            this.$log('[Index GUI Error(loadFirstPage)]', e)
          }
        }
      }
    },
    watch: {
      /*
        이름: uiData
        설명: 공통 스토어에 GUI 설정 정보가 갱신되면 호출한다.
              Store의 State 변경 시 유휴시간 정보를 받아와 변경된 정보로 체크 타이머를 다시 생성한다.
              HealthCheck용 웹소켓 정보를 받아 소켓을 생성한다.
      */
      uiData: {
        deep: true,
        handler (guiData, oldGuiData) {
          // 시스템 설정 저장 - 공통 변수
          // const systemSetting = guiData.system
          // // 이전 uiData 설정 - null일 경우에는 초기 로그인 상태임
          // const oldSystemSetting = oldGuiData ? oldGuiData.system : null

          // 새창열기 시 유효시간 체크기능 제외 (TAMS, cc_flag)
          if (!this.isNewWindow || this.ccFlag) {
            // 유휴시간 체크 시작 - 타이머가 이미 존재하면 Clear
            if (this.checkOverIdleTimer) {
              this.releaseCheckIdleTimer()
            }

            // TAMS - 장비 현황 메뉴 권한 체크
            if (this.menu) {
              const MENU_DEVICE_STATUS = 600200, // 600200: 장비 현황
                MENU_SYNCHRONIZATION_STATUS = 360101, // 360101: 동기화 현황
                MENU_SYNCHRONIZATION_CONFIG = 360102, // 360102: 동기화 설정
                MENU_TICKET_EVENT_STATUS = 220401 // 220401: 티켓 이벤트 설정

              this.$nextTick(() => {
                this.setAuthAlarm(menuCodeToPath(MENU_DEVICE_STATUS, this.menu)) // 미복구 이벤트 알람
                this.setAuthSync(menuCodeToPath(MENU_SYNCHRONIZATION_STATUS, this.menu)) // 동기화 현황 알람
                this.setAuthSyncConfig(menuCodeToPath(MENU_SYNCHRONIZATION_CONFIG, this.menu)) // 동기화 설정 권한
                this.setTicketEvent(menuCodeToPath(MENU_TICKET_EVENT_STATUS, this.menu)) // TICKET EVENT
              })
            }

            // 유휴시간 체크 타이머 시작
            this.setCheckIdleTimer()
          }

          // // 장비 헬스체크
          // if (!oldSystemSetting) {
          //   this.healthCheckOpts.deviceIP = systemSetting.ip
          //   this.healthCheckOpts.devicePort = systemSetting.gui_port
          //
          //   // Health check 웹소켓 생성
          //   this.initHealthCheck()
          // }

          // #27348 - 라이선스 만료 알림창 추가.
          // 로그인 시 라이선스 만료 여부 체크
          try {
            if (!this.isNewWindow && !this.licenseExpiredDay && guiData.license.hasOwnProperty('LicenseInfo') && guiData.license.LicenseInfo.hasOwnProperty('TERM')) {
              let term = guiData.license.LicenseInfo.TERM.split(' ')
              let currentTime = guiData.system.current_time.split(' ')

              // Convert both dates to milliseconds
              let termMs = new Date(term[term.length - 1]).getTime()
              let currentTimeMs = new Date(currentTime[0]).getTime()

              // Calculate the difference in milliseconds
              let diffMs = termMs - currentTimeMs
              let diffDay = Math.round(diffMs / (1000 * 60 * 60 * 24))

              this.licenseExpiredDay = diffDay + 1
              const uiDataVeCode = this.uiData.system.ve_volume.code === 0 || this.uiData.system.ve_volume.code === 999

              if (this.licenseExpiredDay <= 90 || (this.uiData.system.ve_type > 0 && !uiDataVeCode)) {
                // TAMS
                this.$nextTick(() => {
                  this.$refs.licenseExpiredRef.show(this.licenseExpiredDay)
                })
              }
            }
          } catch (e) {
            // this.$log('[Error uiData]:', e)
            // this.$refs.globalAlertDialog.show(this.$t('msg.licenseMgmt_invalidLicense'), 'error')
            // TAMS
            this.$nextTick(() => {
              this.$refs.licenseExpiredRef.show()
            })
          }

          // // HA 장비일 경우 Backup 확인
          // const haInfo = guiData.ha || null
          //
          // // HA 정보가 있고, vsId이 null이 아니면 다음단계 진행
          // if (haInfo && !this.vsId) {
          //   // HA 모드가 Stand-alone이 아니라면 HA 연동 상태로 간주
          //   if (haInfo.mode.toLowerCase() !== 'stand-alone') {
          //     // 현재 장비 찾기
          //     const currentDev = haInfo.mmbr.filter(haMember => haMember.ip === this.healthCheckOpts.deviceIP)
          //
          //     // 현재 장비의 state가 Backup 이라면 백업 마스터 메세지 출력
          //     if (currentDev[0].state !== 'master' && !this.isShowBackupDev) {
          //       // 팝업 메세지 출력
          //       this.$alertPopUp.show(this.$t('msg.default_popup_connectBackupMaster'))
          //
          //       // 메세지 출력 확인
          //       this.isHaBackup = true
          //     }
          //   }
          // }
          this.initRoute()

          this.$nextTick(() => {
            if (this.$loader.isShow) {
              this.$loader.hide() // 최초 화면 로드 시 데이터 대기 로더 숨김 (default.mounted)
            }
          })
        }
      }
    }
  }
</script>

<style>
  /*TAMS 특화 대시보드 drag-drop 영역*/
  .page-content-wrapper {
    min-height: calc(100vh);
  }
  /*.page-content-no-header {*/
  /*  margin-left: 160px;*/
  /*  !*margin-top: 70px;*!*/
  /*  min-height: 530px;*/
  /*  !*padding: 25px 20px 78px 20px;*!*/
  /*  background-color: #f5f6fa;*/
  /*  font-size: 0;*/
  /*}*/
</style>
